import axios from 'axios'

const state = {
  lists: [],
  funds: 0,
  incoming: [],
  hasMore: true,
  page: 1,
  loaded: false,
}

const getters = {}

const mutations = {
  SET_STATE_LOADED(state, flag) {
    state.loaded = flag
  },
  SET_LISTS(state, data) {
    state.lists = data
  },
  SET_MORE_LISTS(state, data) {
    state.lists = state.lists.concat(data)
  },
  SET_HAS_MORE(state, flag) {
    state.hasMore = flag
  },
  SET_INCOMING(state, incoming) {
    state.incoming = incoming
  },
  SET_FUNDS(state, funds) {
    state.funds = funds
  },
  SET_PAGE(state, page) {
    state.page = page
  },
}

const actions = {
  fetchLists,
  fetchMore,
  searchFriends,
  sendGift,
  acceptGift,
  refuseGift,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function fetchLists({ commit, state, rootState }) {
  // Refresh the table
  commit('SET_STATE_LOADED', false)
  commit('SET_LISTS', null)
  commit('SET_PAGE', 1)
  // Fetch the kynd points from the API
  return axios
    .get('/api/v1/getKyndPoints')
    .then((response) => {
      const { data } = response
      // save the lists in Vuex store
      commit('SET_LISTS', data.transactions)
      commit('SET_HAS_MORE', data.has_more)
      commit('SET_INCOMING', data.incoming)
      commit('SET_FUNDS', data.funds)
      if (data.has_more) {
        commit('SET_PAGE', 2)
      }
      return data
    })
    .then(() => {
      commit('SET_STATE_LOADED', true)
    })
}

function fetchMore({ commit, state, rootState }) {
  // Refresh the table
  let { page } = state
  if (!state.hasMore) return
  commit('SET_STATE_LOADED', false)
  // Fetch the kynd points from the API
  return axios
    .get(`/api/v1/getMoreTransactions/${page}`)
    .then((response) => {
      const { data } = response
      // save the lists in Vuex store
      commit('SET_MORE_LISTS', data.transactions)
      commit('SET_HAS_MORE', data.has_more)
      if (data.has_more) {
        commit('SET_PAGE', ++page)
      }
      return data
    })
    .then(() => {
      commit('SET_STATE_LOADED', true)
    })
}

function searchFriends({ commit, state, rootState }, { userTag }) {
  return axios
    .get(`/api/v1/friends/startingWith/${userTag}`)
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}

// quantity: 2
// user_id: 26589
function sendGift({ commit, state, rootState }, params) {
  return axios.post('/api/v1/sendGift', params).then((response) => {
    const { data } = response
    commit('SET_LISTS', data.transactions)
    commit('SET_HAS_MORE', data.has_more)
    commit('SET_INCOMING', data.incoming)
    commit('SET_FUNDS', data.funds)
    return response.data
  })
}

function acceptGift({ commit, state, rootState }, params) {
  return axios.post('/api/v1/acceptGift', params).then((response) => {
    const { data } = response
    commit('SET_LISTS', data.transactions)
    commit('SET_HAS_MORE', data.has_more)
    commit('SET_INCOMING', data.incoming)
    commit('SET_FUNDS', data.funds)
    return response.data
  })
}

function refuseGift({ commit, state, rootState }, params) {
  return axios.post('/api/v1/refuseGift', params).then((response) => {
    const { data } = response
    commit('SET_LISTS', data.transactions)
    commit('SET_HAS_MORE', data.has_more)
    commit('SET_INCOMING', data.incoming)
    commit('SET_FUNDS', data.funds)
    return response.data
  })
}
